/** Event-level gate list (inside the Event Setup section) with the inline "New gate" form. */
import { useState } from "react";
import { Link } from "react-router-dom";
import { PlusIcon } from "@heroicons/react/24/solid";
import { SecondaryButton } from "../../../../components/Button";
import { ACCESS_CONTROL_TYPE, SetupData } from "../types";
import { Chip } from "../ui";
import { NewGateForm } from "./NewGateForm";

export const GatesManager = ({ data, refresh }: { data: SetupData; refresh: () => void }) => {
  const [adding, setAdding] = useState(false);
  const gates = data.gates.filter((g) => g.location_type === ACCESS_CONTROL_TYPE);

  return (
    <div className="border border-gray-200 rounded-md p-4 flex flex-col gap-3">
      <div>
        <div className="text-sm font-semibold text-gray-900">Gates</div>
        <div className="text-sm text-gray-600">The Access Control locations tablets scan tickets at. Which ticket each gate accepts is set per ticket, in its Gates step.</div>
      </div>
      {gates.length === 0 ? (
        <div className="text-sm text-gray-500">No gates yet. Nothing can be scanned until one exists.</div>
      ) : (
        <div className="flex flex-col divide-y divide-gray-100">
          {gates.map((g) => {
            const accepted = (g.redeemable_tokens ?? []).map(String).filter((n) => n.trim());
            return (
              <div key={g.id} className="py-2 flex flex-wrap items-center gap-2">
                <span className="text-sm font-medium text-gray-900">{g.name}</span>
                {g.zone && <Chip>{g.zone}</Chip>}
                {accepted.length ? (
                  <span className="text-xs text-gray-600">accepts {accepted.join(", ")}</span>
                ) : (
                  <Chip tone="red">accepts nothing</Chip>
                )}
                <Link to={`/locations/${g.id}/edit`} className="ml-auto text-xs text-primary-700 hover:text-primary-600 whitespace-nowrap">Edit gate</Link>
              </div>
            );
          })}
        </div>
      )}
      {adding ? (
        <NewGateForm data={data} refresh={refresh} onCancel={() => setAdding(false)} onCreated={() => setAdding(false)} />
      ) : (
        <div>
          <SecondaryButton onClick={() => setAdding(true)}><PlusIcon className="h-4 w-4 mr-1" /> New gate</SecondaryButton>
        </div>
      )}
    </div>
  );
};
